
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySnowShowersDay as ObiLightningHeavySnowShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-snow-showers-day.js';
 
 
 

 
 export const ObiLightningHeavySnowShowersDay = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-snow-showers-day',
   elementClass: ObiLightningHeavySnowShowersDayElement,
   events: {
     
   }
  });
 
 